import React, { useContext, useState, useRef, useEffect } from 'react'
import { GET_FLAG_URL } from '../../constants'
import AppContext from '../context/app'
import useGetAllCountry from '../hooks/useGetAllCountry'
import Dropdown from 'react-bootstrap/Dropdown'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'
import { useTheme } from '@emotion/react'

export default function CountrySelector({ className, style }) {
    const maxHeight = 300
    const theme = useTheme()
    const allCountry = useGetAllCountry()
    const { country } = useContext(AppContext)

    const inputRef = useRef(null)
    const [show, setShow] = useState(false)
    const [userInput, setUserInput] = useState('')

    function changeCountry(country) {
        const event = new CustomEvent("COUNTRY_CURRENCY_CHANGED", { detail: country })
        if (typeof window !== 'undefined') window.dispatchEvent(event)
    }

    const toggle = (e) => {
        setShow(!show)
    }

    useEffect(() => {
        if (show) inputRef.current.focus()
        else setUserInput('')
    }, [show])

    return (
        <Dropdown
            onToggle={toggle}
            show={show}
            className={className}
            style={style}
            css={{
                '& .dropdown-item:hover':{
                    background: theme.colors.secondary
                }
            }}
        >
            <Button
                variant=''
                className='ff-secondary py-1 px-0 fw-bold'
                onClick={toggle}
                style={{ fontSize: 22 }}
            >
                <Stack direction='horizontal' className='align-items-center' gap={1}>
                    <img src={GET_FLAG_URL(country?.countryIso)} alt='' width={32} />
                    <span className='ff-primary text-uppercase text-white'>{country?.name}</span>
                </Stack>
            </Button>

            <Dropdown.Toggle split variant="" className='border-0 py-1'>
                <img src='/svg/chevron-down-icon-white.svg' alt='' />
            </Dropdown.Toggle>

            <Dropdown.Menu className='bg-black rounded-0 border-0 p-0 m-0'>
                <input
                    ref={inputRef}
                    placeholder='Filter countries'
                    name='country-filter'
                    className='placeholder-font-family-primary my-2'
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    style={{ fontSize: 22 }}
                />

                <div style={{ maxHeight }} className='overflow-auto'>
                    {allCountry
                        .filter(({ name }) => name.toLowerCase().includes(userInput.toLowerCase()))
                        .map(c => {
                            const { id, name, countryIso } = c
                            const isActive = countryIso === country?.countryIso

                            return (
                                <Dropdown.Item
                                    key={id}
                                    as={Button}
                                    onClick={() => changeCountry(c)}
                                    className='ff-secondary px-0'
                                    style={{ paddingInline: 12 }}
                                    title={name}
                                    active={isActive}
                                >
                                    <Stack direction='horizontal' className='align-items-center' gap={1}>
                                        <img src={GET_FLAG_URL(countryIso)} alt='' width={32} loading='lazy' />
                                        <span
                                            style={{ fontSize: 18 }}
                                            className={`ff-primary text-uppercase text-white`}
                                        >
                                            {name}
                                        </span>
                                    </Stack>
                                </Dropdown.Item>
                            )
                        })}
                </div>
            </Dropdown.Menu>
        </Dropdown>
    )
}